<template>
  <div id="wrapper">
    <Nav :message="message" />
    <ChopList />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import ChopList from '@/components/admin/ChopList.vue'

export default {
  name: 'chop',
  props: ['message'],
  components: {
    Nav,
    ChopList
  }
}
</script>